// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetPaymentHistory} from '@api';


export const getPaymentHistory = createAsyncThunk('payment/get_payment_trans_history', async args => {
  const response = await GetPaymentHistory(args);
  return response.data;
})

export const paymentHistorySlice = createSlice({
  name: 'paymenthistory',
  initialState: {
    payments: {
      ledgers:[],
      balance:0,
      totalPayment:0,
      initialDeposit:0
    },   
  },
  reducers: {    
  },
  extraReducers: builder => {
    builder
      .addCase(getPaymentHistory.fulfilled, (state, action) => {
        state.payments = action.payload;
      })
  }
})

export default paymentHistorySlice.reducer

